/* eslint-disable no-magic-numbers */
import React from 'react';
import PropTypes from 'prop-types';
import ItemCardMX from 'Components/Listing/listingMXComponents/ItemCard/ItemCard';
import ItemCardCarInd from 'Components/Listing/listingMXComponents/ItemCardCarInd/ItemCardCarInd';
import ExchangeCard from 'Components/Listing/listingMXComponents/ExchangeCard/ExchangeCard';
import SectionTitle from 'Components/Listing/components/Sections/SectionTitle';
import { getIsFeaturedAd, isCocoFofoUser, getVasStripVisibilityForItemRow, getMinPPInd, getMaxPPInd, getIndModFromSection } from 'Helpers/item';
import BrandPromise from 'Components/BrandPromiseCoco/BrandPromise';
import { USER_TYPE } from 'Constants/users';
import ItemPostPlaceholder from 'Components/Listing/components/ItemPostPlaceholder';
import css from '../ItemViewListing/ItemView.APP_TARGET.scss';
import { CONFIG as listConfig } from 'Constants/config';
import CarsPlaceholder from 'Components/Listing/components/CarsPlaceholder';
import { isAutosAvailable } from 'Components/Listing/components/helpers';
import SpotlightItemCard from 'Components/Listing/components/SpotlightItemCard.desktop';
import StaticBannerCarousel from 'Components/Listing/components/StaticBannerCarousel/StaticBannerCarousel';
import { ITEM_SOURCE } from 'Constants/items';

const ItemsList = (
    {
        items, isFetching, showStatistics,
        similarAdsCount, similarAdsData, type, enabledRealImpressions, onViewItem, isAdSuggested,
        visualizationType, itemPostPlaceholderOrigin, itemPostPlaceholderPosition, appliedFiltersLength,
        sectionsItems, listingType, getListingDescription, showInspectionTag, isNewUspVasDesign, shouldRenderZRPWidgets,
        filters, onItemClick, source, sectionsOffset, marketConfig, loadingItems, isListingPage, onVasTagTap, openComparePopup,
        showPlaceHolder, listingBodyType, locationId, dataSrpListItemBanner
    }
) => {
    const isMXCL = marketConfig.get('olxAutos', 'isMXCL');
    const placeholderPosition = itemPostPlaceholderPosition(
        marketConfig,
        itemPostPlaceholderOrigin
    );
    const hideVasTagListing = marketConfig.get('hideVasTagListing');
    const isTradeInFFEnabled = marketConfig.get('enableTradeIn');
    const showExchangeCard = marketConfig.get('olxAutos', 'showExchangeCard') || isTradeInFFEnabled;
    const showModernDesign = marketConfig.get(listConfig.SHOWMODERDESIGN);

    let firstCocoFofoAdEncountered = false;
    let isBrandPromisePlaced = false;

    let showVasStrip = true;
    let showVasStripForPP = true;
    let indDisp = 0; // index displacement for sections
    let nextSec; // variable to store next section offset
    let modPPInd = placeholderPosition;
    let minPPInd = getMinPPInd(modPPInd);
    let maxPPInd = getMaxPPInd(minPPInd);

    const itemPlaceholderClassified = () => {
        if (isAutosAvailable(marketConfig, items, locationId.toString()) && itemPostPlaceholderOrigin !== listConfig.HOME) {
            return (<CarsPlaceholder
                key={ listConfig.CARS_PLACEHOLDER }
                className={ showModernDesign ? css.postCard : '' }
                placeholderPosition={ placeholderPosition }
                items={ items }
            />);
        }
        if (source !== ITEM_SOURCE.HOME && dataSrpListItemBanner && dataSrpListItemBanner && dataSrpListItemBanner?.length > 0) {
            return (
                <StaticBannerCarousel data-aut-id="staticBannerSrpList" items={ dataSrpListItemBanner } />
            );
        }
        return (<ItemPostPlaceholder
            key="postPlaceholder"
            itemPostPlaceholderOrigin={ itemPostPlaceholderOrigin }
            visualizationType={ visualizationType }
            className={ css.postCard }
            hideVasStripForPP={ hideVasTagListing || !showVasStripForPP }
        />);
    };

    let brandPromisePosition = null;
    const getItemList = data => data.map((item, itemIndex) => {
        const membershipType = item.seller_membershiptype;

        const hasSection = sectionsOffset && sectionsOffset.includes(itemIndex);

        // logic for placing brand promise between listing items
        const isFeaturedAd = getIsFeaturedAd(item);

        if (isNewUspVasDesign && (shouldRenderZRPWidgets || appliedFiltersLength > 3)) {
            isBrandPromisePlaced = true;

            brandPromisePosition = null;
        }

        if (!isNewUspVasDesign && !isFeaturedAd && firstCocoFofoAdEncountered && !isBrandPromisePlaced && isListingPage && !similarAdsCount) {
            isBrandPromisePlaced = true;

            brandPromisePosition = itemIndex;

            if (brandPromisePosition % 3) {
                brandPromisePosition = brandPromisePosition + 3 - brandPromisePosition % 3;
            }
        }

        if (!firstCocoFofoAdEncountered) {
            firstCocoFofoAdEncountered = !!isCocoFofoUser(item.user_type);
        }

        if (isNewUspVasDesign && !isBrandPromisePlaced && !similarAdsCount && !similarAdsData?.length) {
            isBrandPromisePlaced = true;

            brandPromisePosition = 12;

            if (brandPromisePosition > items.length) {
                brandPromisePosition = items.length + 3 - items.length % 3;
            }
        }

        if (isNewUspVasDesign && !isBrandPromisePlaced && similarAdsCount && similarAdsData?.length) {
            isBrandPromisePlaced = true;

            brandPromisePosition = 6;
        }

        if (!isBrandPromisePlaced && ((data.length === 1 && firstCocoFofoAdEncountered && !similarAdsData?.length))) {
            isBrandPromisePlaced = true;
            brandPromisePosition = 3;
        }

        if (!isMXCL && !hideVasTagListing) {
            const opArr = getIndModFromSection(hasSection, sectionsOffset, itemIndex, indDisp, modPPInd, placeholderPosition, minPPInd, maxPPInd);

            [nextSec, modPPInd, minPPInd, maxPPInd, indDisp] = opArr;
            showVasStrip = getVasStripVisibilityForItemRow(items, itemIndex, modPPInd, maxPPInd, minPPInd, showVasStrip, nextSec, indDisp);
            // if ppInd set flag for pp vas strip as well
            if (placeholderPosition === itemIndex) {
                showVasStripForPP = showVasStrip;
            }
        }

        let ItemCard;

        if (item?.spotlight_package?.id) {
            ItemCard = SpotlightItemCard;
        }
        else if (isMXCL) {
            ItemCard = ItemCardMX;
        }
        else {
            ItemCard = ItemCardCarInd;
        }
        return (
            <React.Fragment key={ `${item.id}_${itemIndex}` }>
                { hasSection
                    && <SectionTitle
                        section={ sectionsItems && sectionsItems.find(section => section.offset === itemIndex) }
                        isMXCL={ isMXCL }
                    />}
                <ItemCard
                    key={ `${item.id}_${itemIndex}` }
                    item={ item }
                    friendsInCommon={ false }
                    type={ type }
                    enabledRealImpressions={ enabledRealImpressions }
                    onView={ onViewItem }
                    visualizationType={ visualizationType }
                    showStatistics={ showStatistics }
                    listingType={ listingType }
                    getListingDescription={ getListingDescription }
                    filters={ filters }
                    onItemClick={ onItemClick }
                    source={ source }
                    isAdSuggested={ isAdSuggested }
                    chosenOption={ itemIndex }
                    showInspectionTag={ showInspectionTag }
                    onVasTagTap={ onVasTagTap }
                    openComparePopup={ openComparePopup }
                    hideVasStrip={ hideVasTagListing || !showVasStrip }
                    isListingPage={ isListingPage }
                    listingBodyType={ listingBodyType }
                    isNewUspVasDesign={ isNewUspVasDesign }
                    sellerMembershipType={ membershipType }
                    sellerMembershiptype={ membershipType }
                    className={ item?.spotlight_package?.id ? css.spotlightCard : '' }
                    fromHomePage={ false }
                />
            </React.Fragment>
        );
    });
    const itemsList = getItemList(items);

    if (placeholderPosition >= items.length) {
        showVasStripForPP = showVasStrip;
    }
    if (showPlaceHolder && placeholderPosition && items.length) {
        const ItemPlaceholder = isMXCL
            ? (showExchangeCard && !similarAdsCount && items?.length >= 6 && <ExchangeCard
                key="exchangeCard"
                renderSmallExchangeCard={ isNewUspVasDesign }
                itemPostPlaceholderOrigin={ itemPostPlaceholderOrigin }
                visualizationType={ visualizationType }
            />)
            : (!similarAdsCount && items?.length >= 6 && itemPlaceholderClassified());

        itemsList.splice(placeholderPosition, 0, ItemPlaceholder);
    }

    if (isFetching) {
        itemsList.push(loadingItems);
    }
    const showListingBP = marketConfig.get('olxAutos', 'showListingBP');

    if (brandPromisePosition && showListingBP && (!similarAdsCount || isNewUspVasDesign)) {
        const user = {
            dealer: {
                car: {
                    dealer_type: USER_TYPE.COCO
                }
            }
        };

        brandPromisePosition = isNewUspVasDesign && !(showExchangeCard && !similarAdsCount && items?.length >= 6) ? brandPromisePosition + 1 : brandPromisePosition;
        const BrandPromiseElem = <BrandPromise key={ `bp_${brandPromisePosition}` } user={ user } isNewUspVasDesign={ isNewUspVasDesign } onVasTagTap={ isNewUspVasDesign && onVasTagTap } isListingPage />;

        itemsList.splice(brandPromisePosition, 0, BrandPromiseElem);
    }

    return itemsList;
};

ItemsList.propTypes = {
    items: PropTypes.object,
    isFetching: PropTypes.bool,
    showStatistics: PropTypes.bool,
    type: PropTypes.string,
    enabledRealImpressions: PropTypes.bool,
    onViewItem: PropTypes.func,
    isAdSuggested: PropTypes.bool,
    visualizationType: PropTypes.string,
    itemPostPlaceholderOrigin: PropTypes.string,
    itemPostPlaceholderPosition: PropTypes.func,
    sectionsItems: PropTypes.object,
    listingType: PropTypes.string,
    getListingDescription: PropTypes.func,
    showInspectionTag: PropTypes.bool,
    filters: PropTypes.object,
    onItemClick: PropTypes.func,
    source: PropTypes.string,
    sectionsOffset: PropTypes.string,
    locationId: PropTypes.string,
    marketConfig: PropTypes.object,
    loadingItems: PropTypes.object,
    isListingPage: PropTypes.bool,
    onVasTagTap: PropTypes.func,
    openComparePopup: PropTypes.func,
    showPlaceholder: PropTypes.bool,
    appliedFiltersLength: PropTypes.number,
    similarAdsData: PropTypes.array,
    shouldRenderZRPWidgets: PropTypes.bool,
    isNewUspVasDesign: PropTypes.bool,
    similarAdsCount: PropTypes.number,
    categoryID: PropTypes.string,
    listingBodyType: PropTypes.string,
    dataSrpListItemBanner: PropTypes.object
};

export default React.memo(ItemsList);
